import { invoke } from "@tauri-apps/api/core";
import { isTauri } from "@/lib/is-tauri";
import { useTtsSettingsStore } from "@/stores/tts-settings-store";
import { currentVoiceEngine } from "./denker-agent-voice";
import { canSpeak } from "./tts-can-speak";
import { SpeechLookahead } from "./tts-lookahead";

export const speechLookahead = new SpeechLookahead({
  prepare: (request) =>
    invoke<string>("denker_agent_voice_prepare", { ...request }),
  discard: (preparedId) =>
    invoke("denker_agent_voice_discard_prepared", { preparedId }),
});

export function prepareQueuedSpeech(
  text: string,
  eligible: () => boolean,
  allowLong = false,
) {
  const settings = useTtsSettingsStore.getState();
  if (!isTauri() || !canSpeak(settings) || currentVoiceEngine() !== "kokoro")
    return undefined;
  const voice = settings.denkerVoiceId;
  return speechLookahead.register(
    { text, voice },
    () => {
      const current = useTtsSettingsStore.getState();
      return (
        eligible() &&
        canSpeak(current) &&
        current.denkerVoiceId === voice &&
        currentVoiceEngine() === "kokoro"
      );
    },
    allowLong,
  );
}
